export default class Copy
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Copy.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$button = this.DOM.$el.querySelector(this.options.selectorButton)
        this.DOM.$input = this.DOM.$el.querySelector(this.options.selectorInput)

        this.DOM.$button.addEventListener('click', this.onButtonClick.bind(this), { passive: true })
        this.DOM.$el.addEventListener('keydown', this.onKeyDown.bind(this), false)
        if(this.DOM.$input) {
            this.DOM.$input.addEventListener('focus', this.onInputFocus.bind(this), { passive: true })
        }
    }

    onButtonClick() {
        if(this.DOM.$input) {
            this.copyToClipboard(this.DOM.$input.value)
            this.DOM.$input.blur()
        } else {
            this.copyToClipboard(this.DOM.$button.dataset[this.options.dataAttrCopyText])
        }


        this.DOM.$el.addEventListener('animationend', () => {
            this.DOM.$el.classList.remove(this.options.classNameIsCopied)
        }, { once: true, passive: true })

        this.DOM.$el.classList.add(this.options.classNameIsCopied)
    }

    onInputFocus() {
        this.DOM.$input.select()
        this.DOM.$input.setSelectionRange(0, 99999)
    }

    copyToClipboard(text) {
        navigator.clipboard.writeText(text)
        .catch((error) => {
            console.error('Unable to copy text: ', error)
        })
    }

    onKeyDown (e) {
        if (e.key === "Enter") {
            this.onButtonClick(e)
        }
    }
}

Copy.prototype.defaults = {
    classNameIsCopied: 'is-copied',
    dataAttrCopyText: 'copyText',
    selectorButton: '.js-copyButton',
    selectorInput: '.js-copyInput',
}